import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../../../firebase';

const EditCategorieModal = ({ show, handleClose, categorie, handleSave }) => {
    const [updatedCategorie, setUpdatedCategorie] = useState(categorie);
    const [newImage, setNewImage] = useState(null);

    useEffect(() => {
        setUpdatedCategorie(categorie);
        setNewImage(null); // Reset the new image when the category changes
    }, [categorie]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedCategorie(prevCategorie => ({
            ...prevCategorie,
            [name]: value,
        }));
    };

    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setNewImage(e.target.files[0]);
        }
    };

    const onSave = async () => {
        let imageUrl = updatedCategorie.image;
        
        if (newImage) {
            const imageRef = ref(storage, `categories/${newImage.name}`);
            await uploadBytes(imageRef, newImage);
            imageUrl = await getDownloadURL(imageRef);
        }

        const updatedCategorieWithImage = {
            ...updatedCategorie,
            image: imageUrl
        };

        handleSave(updatedCategorieWithImage); // Appeler handleSave du parent avec la Categorie mise à jour
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Modifier la catégorie </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formNom">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            name="nom"
                            value={updatedCategorie.nom || ''}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="formImage">
                        <Form.Label>Image</Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                        {updatedCategorie.image && (
                            <img src={updatedCategorie.image} alt="Categorie" style={{ width: '100px', marginTop: '10px' }} />
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditCategorieModal;
